export const pt = {
  common: {
    next: 'Avançar',
    verify: 'Verificar',
    email_placeholder: 'Digite seu e-mail',
    email_invalid: 'E-mail inválido',
    email_required: 'E-mail é obrigatório',
    password_placeholder: 'Digite sua senha',
    password_required: 'A senha é obrigatória',
    password: 'Senha',
    close: 'Fechar',
    default_error_message:
      'Ocorreu um erro inesperado. Por favor, tente novamente.',
    male: 'Masculino',
    female: 'Feminino',
    scheduling: 'Agendar',
    unknown: 'Desconhecido',
    undifferentiated: 'Indiferenciado',
    md: 'Dr.',
    payment_method: 'Método de pagamento',
    patient_name: 'Paciente',
    type_attendance: 'Tipo de atendimento',
    doctor_name: 'Médico',
    date_and_time: 'Data e hora',
    see_details: 'Ver detalhes',
    common_connectitivy_error:
      'Por favor, tente novamente, ou verifique sua conexão com a internet.',
    from: 'de',
    change: 'Trocar',
    cancel: 'Cancelar',
    save: 'Salvar',
    confirm: 'Confirmar',
    cancel_popup_title: 'Cancelar consulta?',
    cancel_popup_description:
      'Você tem certeza que deseja cancelar esta consulta?',
    look: 'Ver',
    in_person: 'Consulta Presencial',
    online: 'Online',
    timezone: '(Eastern Time, GMT-5)',
    common_field_label_required: 'Campo obrigatório',
    comming: 'Em breve',
    warning_cancelarion_refund_title: 'Cancelamento (Cartão de Crédito)',
    warning_cancelarion_refund: 'Reembolso total',
    warning_cancelarion_no_refund: 'Sem reembolso',
    hours_ahead: 'horas à frente',
    hours_behind: 'horas atrás',
    same_time: 'mesmo horário',
  },
  auth: {
    forgot_password: 'Esqueceu a senha?',
    remember_me: 'Lembrar de mim',
    login_button: 'Entrar',
    create_account: 'Criar conta',
    warning_description:
      'Encontramos um problema técnico ao tentar concluir seu cadastro. Por favor, tente novamente.',
    warning_left_button: 'Ir para home',
    warning_right_button: 'Tentar novamente',
    'Incorrect username or password.': 'E-mail ou senha incorretos.',
    success_token: 'Seu código foi validado',
  },
  create_new_password: {
    code_resend_error: 'Erro ao reenviar o código. Tente novamente.',
    code_resent_info: 'Código reenviado com sucesso para o email: {{email}}',
    email_sent_code:
      'Enviamos um código de 6 dígitos para o seu e-mail: <strong>{{email}}</strong>',
    password_confirmation_required: 'A confirmação de senha é obrigatória',
    enter_your_new_password: 'Digite sua nova senha',
    confirm_your_new_password: 'Confirme sua nova senha',
    confirm_password: 'Confirme a senha',
    password_requirements_title: 'Sua senha deve conter:',
    has_eight_characters: 'Pelo menos 8 caracteres',
    has_one_number: 'Pelo menos 1 número',
    has_one_letter: 'Pelo menos 1 letra',
    btn_create_password: 'Criar senha',
    title_forgot_password: 'Esqueceu sua senha',
    verify_your_email: 'Verifique seu e-mail',
    required_code: 'O Código é obrigatório',
    min_length_password: 'A senha deve ter no mínimo 8 caracteres',
    password_has_number: 'A senha deve conter pelo menos 1 número',
    password_has_letter: 'A senha deve conter pelo menos 1 letra',
    password_not_match: 'As senhas não coincidem',
    title_code_verification: 'Código de verificação',
    resend_code: 'Reenviar',
    subtitle_create_new_password:
      'Crie uma nova senha para proteger sua conta!',
    expiration_time: 'O código expira em ',
    not_received_code: 'Não recebeu o código?',
    'Invalid verification code provided, please try again.':
      'Código de verificação inválido fornecido, tente novamente.',
  },
  forgot_password: {
    error_sending_email: 'Erro ao enviar o e-mail. Tente novamente.',
    btn_email_sent: 'Enviar E-mail',
    email_sent: 'E-mail enviado',
    forgot_password_title: 'Esqueceu sua senha',
    forgot_password_subtitle: 'Cadastrar nova senha',
    forgot_description:
      'Para cadastrar uma nova senha, por favor, informe o e-mail associado à sua conta.',
    resend_code_title: 'Reenviar código',
    account_validation_title: 'Validação de conta',
    account_validation_description:
      'Se você quer validar este email, por favor, siga adiante. Enviaremos um email com o código de validação de conta.',
  },
  signInPersonalInfo: {
    create_account_title: 'Criar nova conta',
    create_account_step_1_subtitle: 'Vamos começar!\n Fale um pouco sobre você',
    create_account_name: 'Nome',
    create_invalid_name: 'Primeiro nome é obrigatório',
    create_invalid_name_less_3:
      'Primeiro nome precisa ter mais de 3 caracteres',
    create_account_surname: 'Sobrenome',
    create_invalid_surname: 'Sobrenome é obrigatório',
    create_invalid_surname_less_3: 'Sobrenome deve ter pelo menos 3 caracteres',
    create_account_birthdate: 'Data de nascimento',
    create_invalid_birthdate: 'Data de nascimento é obrigatória',
    create_account_email: 'E-mail',
    create_invalid_email: 'E-mail é obrigatório',
    create_account_phone: 'Telefone',
    create_invalid_phone: 'Telefone é obrigatório',
    create_less_min_phone_number:
      'O telefone deve ter pelo menos {{minLength}} caracteres',
    create_invalid_country_code: 'DDI inválido',
    create_account_gender: 'Sexo biológico',
    create_account_invalid_gender: 'Sexo biológico é obrigatório',
    create_account_email_already_registered: 'Email já registrado!',
    login_account_email_already_registered_description:
      'Este e-mail já está registrado, mas ainda precisa ser verificado. Confirme agora ou use outro e-mail para continuar.',
    create_account_email_already_registered_resend_password: 'Redefinir senha',
    create_account_email_already_registered_change_email: 'Trocar email',
    create_account_email_already_registered_verify_email: 'Confirmar e-mail',
  },
  signInAddress: {
    create_account_step_2_subtitle:
      'Fique tranquilo, suas informações estão seguras conosco',
    create_account_zip: 'Zip code',
    create_account_invalid_zip: 'O Zip code é obrigatório',
    create_account_invalid_zip_number: 'O Zip code não é um número',
    create_account_invalid_less_min:
      'Zip code deve ter pelo menos 5 caracteres',
    create_account_address: 'Endereço',
    create_account_invalid_address: 'O endereço é obrigatório',
    create_account_city: 'Cidade',
    create_account_invalid_city: 'Cidade é obrigatória',
    create_account_state: 'Estado',
    create_account_invalid_state: 'Estado é obrigatório',
    create_account_complement: 'Complemento',
    create_account_zip_auto_fill_error: 'Zip code inválido',
  },
  signInPassword: {
    create_account_step_3_subtitle: 'Quase lá, hora da senha',
    create_account_password: 'Senha',
    create_account_confirm_password: 'Repetir senha',
    create_account_required_title: 'Sua senha deve conter:',
    create_account_length: 'Ter 8 dígitos',
    create_account_one_number: 'Ter pelo menos 1 número',
    create_account_one_letter: 'Ter pelo menos 1 letra',
    create_account_allow_privacy: 'Política de privacidade',
    create_account_allow_text: 'Concordo com a',
    create_account_terms_middle: 'e com os',
    create_account_terms_end: 'do app',
  },
  signInCode: {
    create_account_step_4_subtitle: 'Verifique seu e-mail',
  },
  success: {
    sign_in_success_title: 'Conta registrada com sucesso!',
    sign_in_success_description:
      'Agora você pode fazer login na sua conta e aproveitar todos os serviços',
    sign_in_success_button: 'Ir para Login',
    password_reset_success_title: 'Senha alterada com sucesso!',
  },
  home: {
    title_next_scheduling: 'Próximos agendamentos',
    see_more: 'Ver tudo',
    service_title: 'Serviços',
    empty_state_title: 'Nenhuma consulta agendada',
    empty_state_description:
      'Agende sua consulta e aproveite cuidados médicos personalizados.',
    schedule_consultation: 'Agendar consulta',
    empty_state_button: 'Agendar consulta',
    available_on: 'Disponível na',
    appstore: 'App Store',
    playstore: 'Play Store',
    qr_code_instruction: 'Escaneie o QR Code para baixar o app!',
    title: 'Tenha acesso a tudo!',
    description:
      'Acesse mais funcionalidades no app! Baixe para cadastrar dependentes, ver histórico e mais.',
  },
  banner: {
    banner_title: 'Tenha acesso a tudo!',
    banner_description:
      'Acesse mais funcionalidades no app! Baixe para cadastrar dependentes, ver histórico e mais.',
    banner_available_in_masc: 'Disponível no',
    banner_available_in_fem: 'Disponível na',
    banner_google_play: 'Google Play',
    banner_app_store: 'App Store',
    banner_scan_qr_code: 'Escanei o QR Code para baixar o app!',
  },
  schedule: {
    schedule_title: 'Novo agendamento',
    schedule_choose_user_subtitle:
      'Vamos começar!\nSelecione para quem será o atendimento',
    schedule_choose_appointment_type_title: 'Escolha o melhor local',
    schedule_choose_appointment_in_person_location_title:
      'Escolha o tipo de consulta',
    schedule_choose_appointment_type_online: 'Consulta online',
    schedule_choose_appointment_type_in_person: 'Consulta presencial',
    schedule_choose_doctor_title: 'Selecione o médico que você deseja',
    screen_choose_doctor_no_prefence: 'Não tenho preferência',
    screen_choose_date_times_title: 'Horários',
    screen_choose_date_no_time:
      'Todos os horários para <bold>{{ date }}</bold> já foram preenchidos. Por favor, selecione outro dia para o agendamento.',
    screen_choose_payment_title: 'Selecione a forma de pagamento',
    screen_choose_confirm_title: 'Confira todas as informações',
    screen_choose_payment_card: 'Cartão de crédito',
    screen_choose_pay_locally: 'Pague localmente',
    screen_choose_add_payment_in_card: 'Registrar um novo cartão',
    screen_choose_pay_total_value: 'Valor total',
    screen_choose_before_confirm_appointment_subtitle:
      'antes de confirmar o agendamento!',
    screen_choose_confirm_schedule_title: 'Confirme todas as informações',
    screen_choose_confirm_schedule_schedule_type: 'Tipo de agendamento',
    screen_choose_confirm_schedule_patient: 'Paciente',
    screen_choose_confirm_schedule_doctor: 'Médico',
    screen_choose_confirm_schedule_date_time: 'Data e horário',
    screen_choose_confirm_schedule_time: 'Horários',
    screen_choose_confirm_schedule_payment_type: 'Forma de pagamento',
    screen_choose_confirm_schedule_appointment_price: 'Valor da consulta',
    screen_choose_confirm_schedule_discount_price: 'Desconto Medstation Card',
    screen_schedule_success:
      'Agendamento confirmado com sucesso! Você já pode consultar suas informações e gerenciar seus agendamento de consultas.',
    screen_reschedule_success:
      'Agendamento alterado com sucesso! Você já pode consultar suas informações e gerenciar seus agendamento de consultas.',
    re_schedule_popup_title: 'Reagendar consulta?',
    re_schedule_popup_description:
      'Não pode comparecer à sua consulta? Reagende agora mesmo.',
    screen_schedule_medstationcard_title: 'Conheça o Medstation Card',
    screen_schedule_medstationcard_text:
      'Consultas, procedimentos e exames com desconto',
    screen_schedule_confirm: 'Confirmar agendamento',
    screen_get_reschedule_error:
      'Erro ao reagendar, por favor confirme o id do agendamento e tente novamente.',
    schedule_no_locations_available: 'Nenhum local disponível',
    modal_error_payment_credit_card_title: 'Ops! Algo deu errado',
    modal_error_payment_credit_card_description:
      'Ocorreu um erro no processamento do seu pagamento, por favor revise as informações do seu cartão.',
    reschedule_title: 'Reagendamento',
  },
  creditCard: {
    screen_credit_card_title: 'Cartão de crédito',
    screen_credit_card_subtitle:
      'Selecione, ou cadastre um novo cartão de crédito',
    screen_credit_card_register_new: 'Cadastrar novo cartão',
    screen_credit_card_delete_popup_title: 'Deletar cartão?',
    screen_credit_card_delete_popup_description:
      'Se excluir este cartão, será necessário adicioná-lo novamente para usá-lo no futuro. Tem certeza de que deseja continuar?',
    screen_credit_card_empty_state_title: 'Cadastrar novo cartão',
    screen_credit_card_empty_state_description:
      'Nenhum cartão cadastrado. Adicione um cartão para continuar com o agendamento.',
    screen_credit_card_register_title: 'Registrar novo cartão de crédito',
    screen_credit_card_register_description:
      'Preencha os dados do cartão de crédito que deseja cadastrar',
    screen_credit_card_register_number: 'Número do Cartão de Crédito',
    screen_credit_card_register_name: 'Nome Impresso no Cartão',
    screen_credit_card_register_date: 'Data de Validade (MM/AA)',
    screen_credit_card_register_code: 'Código de Segurança',
    screen_credit_card_register_number_btn:
      'Clique para preencher o número do cartão',
  },
  whatsAppPopup: {
    whatsAppPopup_title: 'Consulta com seguro saúde?',
    whatsAppPopup_description:
      'Agende sua consulta com seguro saúde pelo WhatsApp. Para pagamentos com cartão de crédito ou Medstation Card, continue aqui.',
    whatsAppPopup_stay_here: 'Continuar aqui',
    whatsAppPopup_go_to_whatsapp: 'Ir para o whatsapp',
  },
  popup: {
    reschedule_appointment: 'Reagendar consulta',
    cancel_appointment: 'Cancelar consulta',
    shure_cancel_appointment: 'Tem certeza que deseja cancelar?',
    cancel_description:
      'Não pode comparecer à sua consulta? Em vez de cancelar, você pode reagendar agora.',
  },
  appointmentDetails: {
    page_title: 'Próximos agendamentos',
    appoitment_title: 'Informações do seu agendamento',
    appoitment_description: 'Resumo do agendamento',
    payment_title: 'Resumo do pagamento',
    reschedule_appointment: 'Reagendar consulta',
    cancel_appointment: 'Cancelar consulta',
    local_payment: 'Pagamento local',
    total_value: 'Valor total',
    back_to_home_btn: 'Voltar',
    view_address: 'Ver endereço',
    access_consultation: 'Acessar consulta',
    online_consultation: 'Consulta online',
    in_person_consultation: 'Consulta presencial',
    consultation_cancelled: 'Consulta cancelada com sucesso!',
    cannot_cancel: 'Você não pode mais reagendar ou cancelar sua consulta.',
    you_can_cancel_or_reschedule_basic: 'Você pode cancelar ou reagendar',
    cancellation_no_refund_reschedule_available:
      'O cancelamento está disponível, porém sem reembolso. Você pode reagendar sem custos até 3 horas antes do horário da sua consulta.',
    you_can_cancel_or_reschedule_with_refund:
      'Você pode cancelar com reembolso ou reagendar sua consulta',
    you_can_cancel_or_reschedule_no_refund:
      'Você pode cancelar sem reembolso ou reagendar sua consulta',
    cannot_reschedule_can_cancel_no_refund:
      'Você não pode mais reagendar, sua consulta vai começar em breve! Cancele sem reembolso.',
    online_consultation_available: 'Ativo 15 min antes da consulta',
  },
  logout: {
    title: 'Sair da sua conta?',
    description:
      'Você está prestes a desconectar. Tem certeza de que deseja sair?',
    lang_en: 'Inglês',
    lang_es: 'Espanhol',
    lang_pt: 'Português',
    short_en: 'EN',
    short_es: 'ES',
    short_pt: 'PT',
  },
  privacyPolicy: {
    create_password: 'Criar senha',
    privacy_policy: 'Política de privacidade',
    how_we_use_and_store: 'Como usamos e armazenamos seus dados',
    last_updated: 'Última atualização em 16 de agosto de 2024',
    introduction: 'Introdução',
    welcome_message:
      'Bem-vindo(a) à MedStation. A privacidade e a segurança dos seus dados são nossas maiores prioridades. Esta Política de Privacidade descreve como coletamos, usamos, compartilhamos e protegemos suas informações pessoais ao utilizar nosso aplicativo. Estamos comprometidos em cumprir todas as leis e regulamentações aplicáveis, incluindo a ',
    hipaa:
      'Lei de Portabilidade e Responsabilidade de Seguro de Saúde (HIPAA).',
    data_collection_title: 'Coleta dos dados',
    data_collection_description: 'Quais dados coletamos',
    data_use_title: 'Uso dos dados',
    data_use_description: 'Como usamos seus dados',
    data_security_title: 'Segurança dos dados',
    data_security_description: 'Como protegemos seus dados',
  },
  dataCollection: {
    title: 'Política de privacidade',
    section1_title: 'Coleta dos dados',
    section1_subtitle: 'Quais dados coletamos',
    section1_item1:
      '• Informações pessoais: Nome, data de nascimento, informações de contato (e-mail, telefone) e endereço.',
    section1_item2:
      '• Informações de saúde: Histórico médico, condições de saúde, prescrições, histórico de consultas.',
    section2_title: 'Como coletamos',
    section2_item1:
      '• Diretamente de você, durante o processo de cadastro, ao agendar consultas, ou interagir com o aplicativo.',
    section2_item2:
      '• Ao cadastrar informações de dependentes no aplicativo, você declara que tem autorização para compartilhar esses dados e concorda, em nome deles, com os termos desta política.',
  },
  dataUse: {
    title: 'Política de privacidade',
    section1_title: 'Uso dos Dados',
    section1_subtitle: 'Por que utilizamos seus dados',
    section1_item1:
      '• Para gerenciar suas consultas médicas e as de eventuais dependentes que você cadastrar.',
    section1_item2:
      '• Para fornecer serviços de saúde personalizados e eficientes.',
    section1_item3:
      '• Para enviar lembretes e notificações relacionadas à sua saúde e aos seus agendamentos.',
    section2_title: 'Compartilhamento de Dados',
    section2_item1:
      '• Com seus profissionais de saúde: Para garantir um atendimento coordenado e eficaz.',
    section2_item2:
      '• Com terceiros confiáveis: Apenas com o seu consentimento e quando necessário, como em laboratórios para realização de exames ou seguradoras de saúde.',
  },
  dataSecurity: {
    title: 'Política de privacidade',
    section_title: 'Segurança dos dados',
    section_subtitle: 'Como protegemos seus dados',
    item1_description:
      '• Conformidade com HIPAA: Cumprimos rigorosamente todas as normas da HIPAA, que protegem as informações de saúde dos pacientes.',
    item2_description:
      '• Criptografia: Todos os seus dados são criptografados tanto em trânsito quanto em repouso, garantindo que suas informações estejam seguras.',
    item3_description:
      '• Controle de acesso: Somente pessoal autorizado tem acesso aos seus dados, e apenas para finalidades legítimas e específicas.',
    item4_description:
      '• Confidencialidade: Todos os dados que você compartilha conosco são tratados como informações confidenciais e são protegidos por rigorosas medidas de segurança. Não divulgamos suas informações pessoais sem o seu consentimento expresso, somente para a prestação de serviços médicos ou conforme exigido por lei.',
  },
  appointment: {
    next_appointments: 'Próximos agendamentos',
    all_appointments: 'Todos os agendamentos',
    empty_filter:
      'Não encontramos resultados com o filtro selecionado. Tente ajustar o filtro ou redefini-lo para visualizar os agendamentos.',
    load_more: 'Carregar mais',
  },
  filter: {
    all_the_appointments: 'Todas as consultas',
    only_my_appointments: 'Somente minhas consultas',
    only_my_dependents: 'Somente dos meus dependentes',
    apply: 'Aplicar',
    clear: 'Limpar tudo',
  },
  deleteAccount: {
    delete_account_title: 'Excluir Conta',
    title: 'Excluir Conta no medstation',
    description: 'Como excluir minha conta e todas as minhas informações',
    section_title: 'Passos',
    section_description: `\n•\tFaça login no aplicativo\n•\tEntre na sua área de perfil (clique na sua foto de perfil ou onde estão suas iniciais, no canto superior esquerdo)\n•\tNas opções, selecione 'Segurança e Privacidade'\n•\tSelecione 'Excluir Conta'\n•\tLeia e marque todas as opções de confirmação de remoção de seus dados, e clique em 'Excluir Conta'\n•\tPronto, agora sua conta foi totalmente removida`,
  },
  termsOfUse: {
    create_password: 'Criar senha',
    title: 'Termos de uso',
    description: 'Como utilizar nossos serviços de forma adequada',
    section_title: 'introduction',
    section_description:
      'O uso dos nossos serviços está sujeito aos seguintes termos e condições, que descrevem as responsabilidades e obrigações dos usuários ao utilizar o aplicativo. Ao concordar com estes Termos de Uso, você declara que está ciente de que esta concordância se aplica tanto a você quanto a quaisquer dependentes que sejam cadastrados por você no aplicativo, garantindo o uso adequado e seguro da plataforma.',
    top_button_title: 'Telemedicina',
    top_button_description: 'Como e quando usar o serviço',
    bottom_button_title: 'Política de cancelamento',
    bottom_button_description: 'Como tratamos cancelamento e reembolso',
  },
  telemedicine: {
    title: 'Telemedicina',
    description: 'Como e quando usar o serviço',
    last_updated: 'Última atualização em 16 de Agosto de 2024',
    presection_description:
      'Ao utilizar nosso aplicativo para agendamento de consultas de telemedicina, você consente com os seguintes termos e condições:',
    section1: 'Modalidades de consulta',
    section1_description:
      '• A consulta de telemedicina pode ser realizada através de videochamada, chamada telefônica ou bate-papo por texto, dependendo da disponibilidade e do acordo com o provedor de saúde.',
    section2: 'Limitações da telemedicina',
    section2_description1:
      '• Você reconhece que a telemedicina oferece um atendimento sem exame físico, sendo assim, não é indicada para emergências médicas. Caso ocorra uma emergência, você deve ligar imediatamente para o serviço de emergência (como o 911).',
    section2_description2:
      '• Entende que o agendamento da consulta pode estar sujeito a atrasos ou remarcações em virtude de prioridades médicas mais urgentes.',
    section3: 'Riscos associados à telemedicina',
    section3_description1:
      '• Durante o uso da telemedicina, podem ocorrer falhas de comunicação entre você e o provedor de saúde. Essas falhas podem impactar o atendimento e o diagnóstico.',
    section3_description2:
      '• A telemedicina pode ter limitações, incluindo, mas não se restringindo a:',
    section3_description2_sub1:
      '• Restrições ou indisponibilidade de exames, prescrições e outros registros médicos;',
    section3_description2_sub2:
      '• Dificuldades do provedor de saúde em realizar uma avaliação física detalhada, o que pode afetar o diagnóstico;',
    section3_description2_sub3:
      '• Atrasos no diagnóstico ou tratamento devido a problemas técnicos, falhas de conexão ou perda de dados.',
    section3_description3:
      '• Você reconhece que esses fatores podem interferir no atendimento e, portanto, não responsabilizará a Medstation por possíveis atrasos ou perdas de informações devido a falhas tecnológicas',
    section4: 'Segurança dos dados',
    section4_description1:
      '• O uso de comunicação eletrônica envolve riscos inerentes. Apesar dos esforços para garantir a segurança, existe a possibilidade de que dados digitais sejam interceptados, modificados ou acessados por terceiros.',
    section4_description2:
      '• Você se reponsabiliza por utilizar usar uma rede segura ao participar de uma consulta de telemedicina.',
    section4_description3:
      '• E entende que mesmo com medidas razoáveis para proteger a confidencialidade, falhas técnicas podem comprometer a transmissão de seus registros médicos.',
  },
  cancellationPolicy: {
    title: 'Política de cancelamento',
    description: 'Como tratamos cancelamento e reembolso',
    last_updated: 'Última atualização em 16 de Agosto de 2024',
    presection_description:
      'Ao utilizar nosso aplicativo para agendamento de consultas de telemedicina, você consente com os seguintes termos e condições:',
    section1: 'Cancelamento com reembolso',
    section1_description:
      '• Cancelamentos devem ser realizados com no mínimo 24 horas de antecedência para garantir o direito ao reembolso.',
    section2: 'Reagendamento',
    section2_description:
      '• Consultas podem ser reagendadas sem custo com até 3 horas de antecedência. Após este prazo, reagendamentos não serão permitidos.',
    section3: 'Reembolso por cartão de crédito',
    section3_description:
      '• Valores pagos via cartão serão reembolsados conforme as políticas da operadora. O prazo para estorno pode variar de acordo com a instituição financeira.',
    section4: 'Cancelamento de consulta presencial',
    section4_description1:
      '• Consultas presenciais podem ser canceladas ou reagendadas com até 3 horas de antecedência.',
    section4_description2:
      '• Se o pagamento já foi realizado via cartão de crédito, o valor será reembolsado conforme as políticas da operadora do cartão. O prazo para o estorno pode variar de acordo com a operadora financeira.',
    section5: 'Cancelamento de consulta presencial',
    section5_description1:
      '• Caso o paciente não compareça a consulta de telemedicina, nossa equipe entrará em contato duas vezes via telefone para tentar remarcar a consulta. Se não houver resposta, o reembolso não será concedido.',
    section5_description2:
      '• Caso o paciente não compareça à consulta presencial, não haverá direito a reembolso, mesmo que o pagamento já tenha sido realizado.',
    bottom_description:
      'Rembolsos não serão concedidos para cancelamentos relacionados a questões que estejam fora do nosso controle, como problemas com farmácias ou medicamentos.',
  },
  errorMessageBack: {
    'It is not allowed to cancel an appointment 3h or less from the date/hour scheduled.':
      'Não é permitido cancelar uma consulta 3h ou menos da data/hora agendada.',

    'Invalid email format': 'Formato de e-mail inválido',
  },
};
